/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ethereum_Chain_Max_Tps_ExplanationInputs */



/**
* | output |
* | --- |
* | "Ethereum previously operated as a PoW network, where block times varied significantly due to the nature of the mining process. In some cases, when a miner so..." |
*
* @param {Ethereum_Chain_Max_Tps_ExplanationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const ethereum_chain_max_tps_explanation = /** @type {((inputs?: Ethereum_Chain_Max_Tps_ExplanationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ethereum_Chain_Max_Tps_ExplanationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Ethereum previously operated as a PoW network, where block times varied significantly due to the nature of the mining process. In some cases, when a miner solved the cryptographic puzzle unusually quickly, a new block could be created in just seconds.<br /><br />This variability explains why Ethereum’s <strong>Max TPS (1 block)</strong> can exceed its <strong>Max Theoretical TPS</strong>.")
});